import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { TableMode } from 'src/app/components/grid/grid.component';
import { FieldDataType } from 'src/app/components/grid/FieldDataType';
import { QueryOperand } from 'src/app/components/grid/QueryOperand';
import { ITableData } from 'src/app/components/grid/ITableData';
import { IColumn } from 'src/app/components/grid/IColumn';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { IExam } from 'src/app/interface/dto';
import { CandidateService } from 'src/app/services/candidate-service.service';

@Component({
  selector: 'app-candidate-seb-lockouts',
  templateUrl: './candidate-seb-lockouts.component.html',
  styleUrls: ['./candidate-seb-lockouts.component.scss']
})
export class CandidateSebLockoutsComponent implements OnInit {
  gridName: string = "sebLockoutsGrid";
  examNo: string = this.activatedRoute.snapshot.params.examno;

  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [
        {
          fieldName: 'ExamNo',
          fieldValue: this.examNo,
          queryOperand: QueryOperand['=='],
          static: true
        }
      ],
      sortParam: {
        fieldName: "",
        orderDirection: 0,
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false
    }
  };

  columns: IColumn[] = [
    {
      displayName: 'Candidate Number',
      fieldName: 'examNo',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Reason',
      fieldName: 'reason',
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'From Lock Screen',
      fieldName: 'fromLockScreen',
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,

    },
    {
      displayName: 'Date/Time',
      fieldName: 'lockoutDateTime',
      fieldDataType: FieldDataType.dateTime,
      searchable: true,
      orderable: true,

    }
  ];

  constructor(private candidateService: CandidateService, private cdRef: ChangeDetectorRef, private activatedRoute: ActivatedRoute) {

  }

  async ngOnInit() {
    GridUtil.setClearGridSelection();
    await this.refreshData(this.data.tableParams);
  }

  async refreshData(tableParams) {
    tableParams.ExamNo = this.activatedRoute.snapshot.params.examno;
    this.examNo = tableParams.ExamNo;
    const res = await this.candidateService.getCandidateSEBLockouts(tableParams) as any[];
    this.updateGridParams(res);
    this.cdRef.detectChanges();
  }

  updateGridParams(res: any) {
    this.data.tableRows = [];
    const tableParams = { ...this.data.tableParams, pageInfo: res[0].pageInfo };
    this.data.tableParams = tableParams;
    this.data.tableRows.push(...res.slice(1, res.length));
  }

  setGridData(rowIds: any[]) {
    if (!this.data?.tableRows) { //Just in case tableRows might still not be ready
      setTimeout(() => this.setGridData(rowIds), 50);
      return;
    }
    let storedIds = GridUtil.getSelectedDataID(this.gridName) ?? [];
    const selectedData: any[] = rowIds.map(x => this.data.tableRows[x] as any).filter(Boolean);
    let selectedDataRowsId = storedIds.length > 0 ? storedIds : selectedData.map(x => x.id);
    GridUtil.setRowCliclk("sebLockoutsGrid", rowIds, selectedDataRowsId);
    //this.setExam(selectedData);
  }
}
